import { LinkIcon, QrCodeIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Dialog from ".";
import { useState } from "react";
// import Checkbox from "../commons/Checkbox";
// import { useTranslat/ion } from "react-i18next";
// import { ChevronDownIcon } from "@heroicons/react/24/solid";

const DialogFastConnect = ({ open, onClose, handleTopUp }) => {
  //   const { t } = useTranslation();
  const [amount, setAmount] = useState("");

  const handleAmountChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, ""); // allow digits only
    setAmount(numericValue);
  };

  return (
    <Dialog open={open} onClose={onClose} width="500px" className="">
      <div>
        {/* <div className="flex items-center justify-end w-full border-b border-[#D9D9D9] pb-1"> */}
        <div className="flex items-center justify-start w-full relative">
          <h2 className="text-base font-bold text-[#21272A] flex items-center">
            <QrCodeIcon className="w-[18px] h-[18px] mr-2" /> OKX - Fast Connect
          </h2>
          <button
            className="bg-transparent hover:bg-transparent text-black absolute right-0"
            onClick={onClose}
          >
            <XMarkIcon className="w-[18px] h-[18px]" />
          </button>
        </div>

        <div className="mt-6 space-y-5">
          <div className="w-full flex items-start gap-3">
            <span className="w-full max-w-[28px] text-base flex justify-center items-center h-[28px] rounded-full bg-[#D9D9D9]">
              1
            </span>
            <p className="text-base m-0">
              Click the connect button, and you will be directed to OKX account.
            </p>
          </div>
          <div className="w-full flex items-start gap-3">
            <span className="w-full max-w-[28px] text-base flex justify-center items-center h-[28px] rounded-full bg-[#D9D9D9]">
              2
            </span>
            <p className="text-base m-0">
              Login to your OKX account in OKX website.
            </p>
          </div>
          <div className="w-full flex items-start gap-3">
            <span className="w-full max-w-[28px] text-base flex justify-center items-center h-[28px] rounded-full bg-[#D9D9D9]">
              3
            </span>
            <p className="text-base m-0">
              Confirm your connection to Xenorize.
            </p>
          </div>
        </div>

        <div className="mt-8">
          <button
            type="submit"
            // theme={!amount ? ButtonTheme.Gray : ButtonTheme.Default}
            // disabled={!amount}
            className="w-full relative overflow-hidden !py-3 !font-bold !text-lg !bg-[#007A78] rounded-xl"
            // onClick={() => onNext()}
          >
            Connect
          </button>

          <div className="flex items-center gap-1 justify-center mt-3">
            <span className="text-sm">
              Don't have an account? Create a new OKX account.
            </span>
            <LinkIcon className="w-[20px] h-[20px]" />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogFastConnect;
